import type { HelpFile } from '../../types/help'
import { DatabaseConfigCardTestIds } from '../../../testids/DatabaseConfigCardTestIds'

export const databaseConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/outbound',
  texts: {
    [DatabaseConfigCardTestIds.databaseConfigCard]:
      'Datenbankverbindungseinstellungen für diesen ausgehenden Konnektor — Treibertyp, Host, Anmeldedaten und Pool-Größe.',
    [DatabaseConfigCardTestIds.cardTitleDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.btnCreateDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.btnEditDatabaseConfig]: null,
    [DatabaseConfigCardTestIds.selectDatabaseType]:
      'Datenbank-Engine — Postgres, Oracle, MS SQL usw.',
  },
}
